{
	"actions": {
		"cancel": "Annulla",
		"copy_link": "Copia link",
		"edit": "Modifica link",
		"open_menu": "Apri azioni",
		"revoke": "Revoca"
	},
	"change_expiry": {
		"out_of_range": "Quella data non rientra in ciò che la tua organizzazione consente.",
		"out_of_range_days_one": "La scadenza può essere al massimo {{count}} giorno da oggi.",
		"out_of_range_days_other": "La scadenza può essere al massimo {{count}} giorni da oggi.",
		"refusal": {
			"incomplete": "Completa la data: giorno, mese e anno.",
			"invalid": "Questo giorno non esiste. Controlla il giorno e il mese.",
			"required": "Serve una data: scegline una per salvare.",
			"too_early": "Questa data è già passata. La scadenza parte da domani."
		}
	},
	"columns": {
		"access_count": "Aperture",
		"expiry": "Scadenza",
		"kind": "Tipo",
		"password": "Password",
		"resource": "Risorsa",
		"state": "Stato"
	},
	"edit": {
		"description": "Link a «{{name}}». Le modifiche valgono subito.",
		"done": "Link aggiornato.",
		"password": {
			"missing": "Scrivi una password per proteggere il link.",
			"required_refusal": "La tua organizzazione richiede una password su ogni link, quindi non si può togliere."
		},
		"pending": "Salvataggio…",
		"submit": "Salva",
		"title": "Modifica link"
	},
	"empty": {
		"description": "Crea un link dal menu di un file o di una cartella per condividerlo fuori dalla tua organizzazione.",
		"disabled_description": "Il tuo amministratore ha disattivato i link pubblici per questa organizzazione.",
		"disabled_title": "I link sono disattivati",
		"no_matches_description": "Prova un filtro diverso.",
		"no_matches_title": "Nessun link corrisponde a questo filtro",
		"title": "Nessun link attivo"
	},
	"expiry": {
		"never": "Nessuna scadenza"
	},
	"filters": {
		"state": "Stato"
	},
	"kind": {
		"download": "Condivisione",
		"upload": "Link di caricamento"
	},
	"kind_filter": {
		"all": "Tutti",
		"download": "Condivisione",
		"upload": "Link di caricamento"
	},
	"page_title": "I miei link attivi",
	"password": {
		"no": "Nessuna password",
		"yes": "Protetto da password"
	},
	"refusal": {
		"not_found": "Questo link non esiste più. Aggiorna l'elenco."
	},
	"revoke": {
		"confirm": "Revoca",
		"description": "Il link smette di funzionare immediatamente.",
		"done": "Link revocato.",
		"pending": "Revoca in corso…",
		"title": "Revocare questo link?"
	},
	"search_placeholder": "Cerca per risorsa",
	"state": {
		"active": "Attivo",
		"expired": "Scaduto",
		"policy_blocked": "Bloccato da policy",
		"revoked": "Revocato"
	},
	"state_helper": {
		"policy_blocked": "Riprende automaticamente se il tuo amministratore riattiva i link."
	},
	"view": {
		"all": "Tutti",
		"expired": "Scaduti",
		"live": "Attivi",
		"revoked": "Revocati"
	}
}
